import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InfoIcon from '@mui/icons-material/Info';
import { WoundApi } from '../../apis/index';

const WoundMetaList = (props) => {
  const [wounds, setWounds] = useState([]);

  const firstSerach = async () => {
    const res = await WoundApi.getWoundList();
    setWounds(res.data);
  };
  useEffect(() => {
    firstSerach();
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID' },
    { field: 'woundName', headerName: 'woundName', width: 200 },
    { field: 'woundType', headerName: 'woundType', width: 200 },
    { field: 'ink2Ratio', headerName: 'ink2Ratio', width: 200 },
    { field: 'stlThreshold', headerName: 'stlThreshold', width: 200 },
  ];

  const handleRowSelection = (e) => {
    props.history.push('/updateWoundMeta/' + e.row.id);
  };
  return (
    <div>
      <Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ paddingBottom: 10 }}
        >
          <div
            variant="h6"
            style={{ fontWeight: 'bold', color: 'rgb(63, 89, 140)' }}
          >
            WOUND INFO
          </div>
          <button className="blue">
            <Link to="/saveWoundMeta">
              <InfoIcon
                label="wound"
                style={{
                  color: 'rgb(63, 89, 140)',
                  opacity: '90%',
                }}
              />
              <button className="blue">Wound Insert</button>
            </Link>
          </button>
        </Grid>
      </Grid>

      <div style={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={wounds}
          columns={columns}
          pageSize={10}
          //onRowSelected={handleRowSelection}
          onRowClick={handleRowSelection}
        />
      </div>
    </div>
  );
};

export default WoundMetaList;
